<script setup lang="ts"></script>

<template>
  <icon name="lucide:upload" />
</template>

<style scoped></style>
